import {BaseComponent} from '../base.component';
import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
})
export class TitleComponent extends BaseComponent {

  @Input() title: string;

  constructor() {
    super();
  }
}
